<p-confirmDialog key="offenderlookupverifiedtable" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div>
	<p-table
		#mydt
		[value]="lstOffender"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="single"
		[(selection)]="SelectedOffender"
		dataKey="OffenderID"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>
				<!--INSERT CUSTOM FILTERS HERE-->

				<!--PersonName-->
				<th>
					<p-columnFilter type="text" field="PersonName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--DOB-->
				<th>
					<!-- <p-columnFilter type="text" field="DOB" matchMode="contains" [showMenu]="true"></p-columnFilter> -->
				</th>

				<!--IsMatchDesc-->
				<th>
					<p-columnFilter field="IsMatchDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterIsMatchDesc
								[ngModel]="value"
								[options]="lstIsMatchDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--AdminName-->
				<th>
					<p-columnFilter type="text" field="AdminName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<th></th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th></th>
				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="PersonName">Name<p-sortIcon field="PersonName"></p-sortIcon></th>
				<th pSortableColumn="DOB">DOB<p-sortIcon field="DOB"></p-sortIcon></th>
				<th pSortableColumn="IsMatchDesc">Match<p-sortIcon field="IsMatchDesc"></p-sortIcon></th>
				<th pSortableColumn="AdminName">Admin<p-sortIcon field="AdminName"></p-sortIcon></th>
				<th></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Offender>
			<tr [pSelectableRow]="Offender">
				<td>
					<img [src]="Offender.OffenderPhoto" />
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Offender[col.field] }}
				</td>

				<td>
					<button class="btn btn-warning" (click)="onReVerify(Offender.OffenderID)">Re-Verify</button>
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>
